import React from 'react'
import PropTypes from 'prop-types'
import './Hamburger.scss'

const Hamburger = ({isOpen, toggleOpen}) => (
  <div className="hamburger-wrapper">
    <button
      className={`c-hamburger c-hamburger--htx ${isOpen ? 'is-active' : ''}`}
      onClick={toggleOpen}
    >
      <span>toggle men</span>
    </button>
  </div>
)

Hamburger.propTypes = {
  isOpen: PropTypes.bool,
  toggleOpen: PropTypes.func
}

Hamburger.defaultProps = {
  isOpen: false,
  toggleOpen: null
}

export default Hamburger



// WEBPACK FOOTER //
// ./components/Hamburger/index.jsx